import moment from 'moment-timezone'

export const TaskStatuses = new Set(['incomplete', 'complete', 'deleted'])

export const SettingTypes = {
  no_show: 'missed appointment',
  reminder: 'next appointment',
  onboarding: 'first appointment',
  recall: 'recall',
  custom: 'custom',
  custom_post: 'custom post',
  custom_recall: 'custom recall',
  custom_no_show: 'custom missed appointment',
  template: 'template',
  missed_call: 'missed call',
}

const mapKeysToArr = dict =>
  Object.keys(dict).reduce(
    (idsByType, currType) => ({
      ...idsByType,
      [currType]: [],
    }),
    {},
  )

export const initSettingTypeKeys = () => mapKeysToArr(SettingTypes)

export const Products = {
  dso: 'DSO',
  reminders: 'Reminders,',
  reminderstier2: 'Reminders Tier 2',
  openchair: 'Open Chair',
  voip: 'Voip',
  missedcalltext: 'Missed Call Text',
  patientPortal: 'Patient Portal',
  marketing: 'Marketing',
  reviews: 'Reviews',
  textingonly: 'Texting Only',
  topsremindersplus: 'Reminders Plus',
  topsalertsplus: 'Alerts Plus',
}

export const hasProducts = productSet => ({
  hasDSO: productSet.has('dso'),
  hasMarketing: productSet.has('marketing'),
  hasNewPatientOS: productSet.has('openchair'),
  hasPatientPortal: productSet.has('patientportal'),
  hasReminders: productSet.has('reminders'),
  hasRemindersTier2: productSet.has('reminderstier2'),
  hasReviews: productSet.has('reviews'),
  hasScreenPop: productSet.has('voip'),
  hasMissedCallText: productSet.has('missedcalltext'),
  hasTextingOnly: productSet.has('textingonly'),
  hasTopsAlertsPlus: productSet.has('topsalertsplus'),
  hasTopsRemindersPlus: productSet.has('topsremindersplus'),
})

const errorCodes = {
  12300: 'Media type invalid',
  21211: 'Invalid patient number',
  21408: "Texting is not enabled for patient's country",
  21606: 'Texting is not enabled for practice number',
  21610: 'Blacklisted From/To pair',
  21612: 'Patient number is improperly formatted',
  21614: 'Patient number is not mobile',
  30003: 'Patient number is physically unreachable',
  30004: 'Practice number is blocked by patient',
  30005: 'Unknown/inactive patient number',
  30006: 'Patient number is landline or unreachable',
  30007: 'Practice number is blocked by patient',
  30008: 'Unknown error',
}

export const getDescription = errorCode =>
  errorCodes.hasOwnProperty(errorCode) ? errorCodes[errorCode] : 'Unknown error'

const getTimeRange = (startMoment, endMoment) => () =>
  [startMoment.toISOString(), endMoment.toISOString()]
const now = () => moment()
const tomorrow = () => moment().add(1, 'days')
const nextWeek = () => moment().add(1, 'weeks')
const twoWeeksFromNow = () => moment().add(2, 'weeks')
const threeWeeksFromNow = () => moment().add(3, 'weeks')

const buildPatientSearchFilters = () => [
  {
    id: 'all',
    param: null,
    value: null,
    name: 'All',
  },
  {
    id: 'hour',
    param: 'appointment_range[]',
    value: getTimeRange(now(), now().add(1, 'h')),
    name: 'In One Hour',
  },
  {
    id: 'today',
    param: 'appointment_range[]',
    value: getTimeRange(now(), now().endOf('day')),
    name: 'Today',
  },
  {
    id: 'todaymorning',
    param: 'appointment_range[]',
    value: getTimeRange(now(), now().set('hour', 12)),
    name: 'This Morning',
  },
  {
    id: 'todayafternoon',
    param: 'appointment_range[]',
    value: getTimeRange(now(), now().set('hour', 23)),
    name: 'This Afternoon',
  },
  {
    id: 'tomorrow',
    param: 'appointment_range[]',
    value: getTimeRange(tomorrow().startOf('day'), tomorrow().endOf('day')),
    name: 'Tomorrow',
  },
  {
    id: 'tomorrowmorning',
    param: 'appointment_range[]',
    value: getTimeRange(tomorrow().startOf('day'), tomorrow().set('hour', 12)),
    name: 'Tomorrow Morning',
  },
  {
    id: 'tomorrowafternoon',
    param: 'appointment_range[]',
    value: getTimeRange(tomorrow().set('hour', 12), tomorrow().set('hour', 23)),
    name: 'Tomorrow Afternoon',
  },
  {
    id: 'week',
    param: 'appointment_range[]',
    value: getTimeRange(now(), now().endOf('week')),
    name: `This Week (${now().format('MMM D')} - ${now()
      .endOf('week')
      .format('MMM D')})`,
  },
  {
    id: 'nextweek',
    param: 'appointment_range[]',
    value: getTimeRange(nextWeek().startOf('week'), nextWeek().endOf('week')),
    name: `Next Week (${nextWeek()
      .startOf('week')
      .format('MMM D')} - ${nextWeek().endOf('week').format('MMM D')})`,
  },
  {
    id: 'nexttwoweeks',
    param: 'appointment_range[]',
    value: getTimeRange(
      twoWeeksFromNow().startOf('week'),
      twoWeeksFromNow().endOf('week'),
    ),
    name: `${twoWeeksFromNow()
      .startOf('week')
      .format('MMM D')} - ${twoWeeksFromNow().endOf('week').format('MMM D')}`,
  },
  {
    id: 'nextthreeweeks',
    param: 'appointment_range[]',
    value: getTimeRange(
      threeWeeksFromNow().startOf('week'),
      threeWeeksFromNow().endOf('week'),
    ),
    name: `${threeWeeksFromNow()
      .startOf('week')
      .format('MMM D')} - ${threeWeeksFromNow().endOf('week').format('MMM D')}`,
  },
]

export const patientFilters = buildPatientSearchFilters()



// WEBPACK FOOTER //
// ./src/state/constants.js